import React from 'react';
import Layout from '../../components/Layout';
import Brand from './Brand';
import { getProducts, updateFiltersFromParams } from '../../actions/shop';
import { getPagePresentationKeys } from '../../actions/page';
import { PER_PAGE } from '../../constants';
import { getShopParams } from '../../helpers';

const pageName = 'brand';
async function action({ store, query }) {
  const {
    shop: { currentPage = 1 },
  } = store.getState();
  const params = getShopParams(query);

  const {
    byName: {
      [pageName]: { pageDescription },
    },
  } = await store.dispatch(getPagePresentationKeys({ pageName }));

  await store.dispatch(updateFiltersFromParams(params));

  const { min, max, ...paramsWithoutMinMax } = params;

  await store.dispatch(
    getProducts({
      page: 1,
      perPage: currentPage * PER_PAGE,
      params: {
        ...paramsWithoutMinMax,
        min: 1,
        max: 900000,
      },
    }),
  );

  return {
    chunks: ['shop'],
    title: 'Brands',
    description: pageDescription,
    component: (
      <Layout footer={false} footerBar redeemOverview>
        <Brand store={store} />
      </Layout>
    ),
    addCompanyMarkup: true,
  };
}

export default action;
